import { render, staticRenderFns } from "./DialogPix.vue?vue&type=template&id=b075a8e6&"
import script from "./DialogPix.vue?vue&type=script&lang=js&"
export * from "./DialogPix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports